import * as React from "react";
import { Icon } from "./Icon";

export class FolderIcon extends Icon {

	render() {
		return <Icon {...this.props}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
				<path d="M14,8V4H2v4v20h28V8H14z M28,26H4V10h24V26z" />
			</svg>
		</Icon>;
	}
}